module.exports = __webpack_public_path__ + "static/media/delivery-dining.b79733ce.svg";